import React from 'react'
import { Page, Text, Document, StyleSheet } from '@react-pdf/renderer';


export default function ChoicesTab(props) {

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            width: "100%",
            padding: 10
        },
        part: {
            flexDirection: 'column',
            marginTop: 10
        },
        text: {
            fontSize: 9
        },
        title: {
            fontSize: 12
        }
    })

    const menuCount = props.choices.reduce((acc, d) => {
        acc[d.menu] = (acc[d.menu] || 0) + 1;
        return acc;
    }, {});

    const entryCount = props.choices.reduce((acc, d) => {
        acc[d.entree] = (acc[d.entree] || 0) + 1;
        return acc;
    }, {});

    const platCount = props.choices.reduce((acc, d) => {
        acc[d.plat] = (acc[d.plat] || 0) + 1;
        return acc;
    }, {});

    const laitageCount = props.choices.reduce((acc, d) => {
        acc[d.laitage] = (acc[d.laitage] || 0) + 1;
        return acc;
    }, {});

    const dessertCount = props.choices.reduce((acc, d) => {
        acc[d.dessert] = (acc[d.dessert] || 0) + 1;
        return acc;
    }, {});

    const potageCount = props.choices.reduce((acc, d) => {
        if (d.potage && d.potagenbr && d.potagenbr !== "0") {
            acc[d.potage] = (acc[d.potage] || 0) + parseInt(d.potagenbr, 10);
        } else if (d.potage && d.potagenbr === undefined) {
            acc[d.potage] = (acc[d.potage] || 0) + 1;
        }        
        return acc;
    }, {});

    const brickCount = props.choices.reduce((acc, d) => {
        if (d.brick && d.bricknbr && d.bricknbr !== "0") {
            acc[d.brick] = (acc[d.brick] || 0) + parseInt(d.bricknbr, 10);
        } else if (d.brick && d.bricknbr === undefined) {
            acc[d.brick] = (acc[d.brick] || 0) + 1;
        }        
        return acc;
    }, {});

    const dinerCount = props.choices.reduce((acc, d) => {
        if (d.diner) {
            acc[d.diner] = (acc[d.diner] || 0) + 1;
        }        
        return acc;
    }, {});

    const listItems = props.choices.map((d) => 
        <view style={styles.part} wrap={false}>
            <Text>----------------------------------------------------------------------------------------------</Text>
            <Text style={styles.text}>Date : {d.date}</Text><br/>
            <Text style={styles.text}>Client : {d.customer}</Text><br/>
            <Text style={styles.text}>Menu : {d.menu}</Text><br/>
            <Text style={styles.text}>Entrée : {d.entree}</Text><br/>
            <Text style={styles.text}>Plat : {d.plat}</Text><br/>
            <Text style={styles.text}>Laitage : {d.laitage}</Text><br/>
            <Text style={styles.text}>Dessert : {d.dessert}</Text><br/>
            { d.potage === undefined ? null : <><Text style={styles.text}>Potage : {d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/></>}
            { d.brick === undefined ? null : <><Text style={styles.text}>Brique : {d.bricknbr} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/></>}
            { d.diner === undefined ? null : <><Text style={styles.text}>Diner léger : {d.diner}</Text><br/></>}
            { d.boule === "0" ? null : <><Text style={styles.text}>Boule : {d.boule}</Text><br/></>}
            { d.baguette === "0" ? null : <><Text style={styles.text}>Baguette : {d.baguette}</Text><br/></>}
            { d.nature === "0" ? null : <><Text style={styles.text}>Pain de mie nature : {d.nature}</Text><br/></>}
            { d.complet === "0" ? null : <><Text style={styles.text}>Pain de mie complet : {d.complet}</Text><br/></>}
            { d.comment === undefined ? null : <><Text style={styles.text}>Commentaire : {d.comment}</Text><br/></>}
        </view>);

    return (
        <Document title="recap.pdf">
            <Page style={styles.page} size="A4" orientation='portrait'>
                <Text style={styles.title}>Récap de commande du {props.date}</Text>
                <view style={styles.part}>{listItems}</view>
                <Text>----------------------------------------------------------------------------------------------</Text>
                <view style={styles.part}>
                    <Text style={styles.title}>Menus :</Text>
                        {Object.entries(menuCount).map(([menu, count]) => (
                            <Text key={menu} style={styles.text}>{menu} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Entrées :</Text>
                        {Object.entries(entryCount).map(([entree, count]) => (
                            <Text key={entree} style={styles.text}>{entree} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Plats :</Text>
                        {Object.entries(platCount).map(([plat, count]) => (
                            <Text key={plat} style={styles.text}>{plat} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Laitages :</Text>
                        {Object.entries(laitageCount).map(([laitage, count]) => (
                            <Text key={laitage} style={styles.text}>{laitage} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Desserts :</Text>
                        {Object.entries(dessertCount).map(([dessert, count]) => (
                            <Text key={dessert} style={styles.text}>{dessert} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Potages :</Text>
                        {Object.entries(potageCount).map(([potage, count]) => (
                            <Text key={potage} style={styles.text}>{potage} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Briques :</Text>
                        {Object.entries(brickCount).map(([brick, count]) => (
                            <Text key={brick} style={styles.text}>{brick} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
                <view style={styles.part}>
                    <Text style={styles.title}>Diners :</Text>
                        {Object.entries(dinerCount).map(([diner, count]) => (
                            <Text key={diner} style={styles.text}>{diner} : <Text style={{fontFamily: "Helvetica-Bold"}}>{count}</Text></Text>
                        ))}
                </view>
            </Page>
        </Document>
    )
}